import { Button } from '@shared/components/ui/button';
import { useTranslation } from 'react-i18next';

interface ErrorStateProps {
  error: string | null;
  onRetry: () => void;
}

export const ErrorState = ({ error, onRetry }: ErrorStateProps) => {
  const { t } = useTranslation('legacyDashboardModule');

  return (
    <div className="flex items-center justify-center min-h-[calc(100vh-150px)]">
      <div className="text-center">
        <div className="text-destructive text-4xl mb-4">⚠️</div>
        <h3 className="text-lg font-semibold text-foreground mb-2">{t('error.title')}</h3>
        <p className="text-muted-foreground mb-4">{error ?? '-'}</p>
        <Button onClick={onRetry}>{t('error.retry')}</Button>
      </div>
    </div>
  );
};
